import { Injectable } from '@angular/core';
import { CommonService } from './common.service';
import { Pagination, StatusCode } from '../constants';
import { Observable } from 'rxjs';
import { ResponseResult } from '../interfaces';

@Injectable({
    providedIn: 'root',
})
export class ContractService {
    constructor(private commonService: CommonService) {}

    getAll(
        filter: string = '',
        pageIndex: number = Pagination.PageIndex,
        pageSize: number = Pagination.PageSize
    ): Observable<ResponseResult> {
        if (filter !== '') {
            return this.commonService.getAll(
                `contract?filter=${filter}`,
                true,
                pageSize,
                pageIndex
            );
        }
        return this.commonService.getAll(
            `contract`,
            false,
            pageSize,
            pageIndex
        );
    }

    getDataByBody(
        model: any = [],
    ): Observable<ResponseResult> {
        return this.commonService.getDataByBody(
            `contract/filter`,
            model,
            model.langId,
            model.parentId
        );
    }

    getCrudeProduct(model): Observable<ResponseResult> {
        return this.commonService.getDataByBody(
            `contract/crude-product`,
            model,
            model.langId,
            model.parentId
        );
    }

    create(model): Observable<ResponseResult> {
        return this.commonService.createData(
            `contract`,
            model,
            model.langId,
            model.parentId
        );
    }

    update(model): Observable<ResponseResult> {
        return this.commonService.updateData(`contract/${model.id}`, model);
    }
    updateStatus(model): Observable<ResponseResult> {
        return this.commonService.updateData(`contract/update-status/${model.id}`, model);
    }
    reCallApi(model): Observable<ResponseResult> {
        return this.commonService.updateData(`contract/recall-api/${model.id}`, model);
    }
    getDetail(id: number): Observable<ResponseResult> {
        return this.commonService.getById(`contract/${id}/detail`);
    }
    delete(id: number): Observable<ResponseResult> {
        return this.commonService.deleteData(`contract/${id}`);
    }

    getBeanSelectionForm(id) {
        return this.commonService.getById(`contract/bean-selection-form/${id}`);
    }

    getReportContractInfo(model): Observable<ResponseResult> {
        return this.commonService.getDataByBody(
            `contract/report-contract-info`,
            model,
            model.langId,
            model.parentId
        );
    }

    getCrudeProductById(model): Observable<ResponseResult> {
        return this.commonService.getDataByBody(
            `contract/crude-product-by-id`,
            model
        );
    }
    
    exportBeanSelectionFormToExcel(id): Observable<any> {
        return this.commonService.downloadPdfFile(`contract/export-bean-selection-form-to-pdf/${id}`);
    }

    exportCrudeProductById(model): Observable<any> {
        return this.commonService.downloadExcelFileByPost(`contract/crude-product-by-id/export`, model);
    }
}
